import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';

import { PRODUCT_FRAGMENT } from '../../../component/productPreview/ProductPreview';
import ProductsListItem from '../../../component/productsList/productsListItem/ProductsListItem';
import { ONE_DAY, ONE_MINUTE, truncateDate } from '../../../util/date';

import './HiddenGems.css';

const HIDDEN_GEMS_PRODUCTS = gql`
  query HiddenGems($filter: ProductFilter!, $sort: String!, $limit: Int!) {
    items: searchProducts(filter: $filter, sort: $sort, limit: $limit) {
      ...ProductFragment
      id
      createdAt
      category
      title
      brand
      price
      original_price
      status
      external_url
      resizedSmallImages
      is_visible
      size
      condition
      discount_rate
      like_count
      is_liked
    }
  }
  ${PRODUCT_FRAGMENT}
`;

/**
 * 홈화면 숨겨진 보석 섹션
 * @returns {JSX.Element}
 * @constructor
 */
export default function HiddenGems() {
    const [dates, setDates] = useState(null);

    useEffect(() => {
        setDates({
            createdFrom: new Date(truncateDate(new Date(), ONE_MINUTE) - 8 * ONE_DAY),
            createdUntil: new Date(truncateDate(new Date(), ONE_MINUTE) - 7 * ONE_DAY),
        });
    }, []);

    const { data } = useQuery(HIDDEN_GEMS_PRODUCTS, {
        variables: {
            filter: {
                created_from: dates?.createdFrom,
                created_until: dates?.createdUntil,
                show_only: 'selling',
                minBrandScore: 0,
            },
            sort: 'HIGH_VIEW',
            limit: 6,
        },
        skip: !dates,
        fetchPolicy: 'cache-and-network',
    });

    const items = data?.items ?? [];

    return (
        <section className="HiddenGems">
            <div className="HiddenGems-inner">
                <div className="HiddenGems-header">
                    <div>
                        <div className="HiddenGems-tag">CURRENT HIDDEN GEMS</div>
                        <h2 className="HiddenGems-title">숨겨진 명품</h2>
                    </div>
                </div>
                <div className="HiddenGems-grid">
                    {items.map((product) => (
                        <ProductsListItem key={product.id} product={product} />
                    ))}
                </div>
            </div>
        </section>
    );
}
